import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

@Injectable({
    providedIn: 'root'
  })
export class ExcelExportService {
    
    
    constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

    exportExcel(reportTitle: string, columnNames: string[], lst: {[key: string]: string}[], columnWidths: string, 
        generatedBy: string, generatedOn: string) {
        const header = columnNames;//Object.keys(lst[0]);
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet(reportTitle);
        worksheet.views = [
            {state: 'frozen', ySplit: 3}
        ];
        let titleRow = worksheet.addRow([reportTitle]);
        titleRow.font = {
            name: 'Calibri',
            size: 20,
            bold: true,
        }

        worksheet.mergeCells('A1:E1'); 

        let createdByOnRow = worksheet.addRow(['Generated By', generatedBy, 'Generated On', generatedOn]);
        createdByOnRow.eachCell((cell, number) => {
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 12, 
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });

        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '808080' },
            }
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 14,
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });
        const list = []

        lst.forEach((row: any) => {
            let ls = [];
            for(let t = 0; t < columnNames.length; t++) {
                ls.push(row[columnNames[t]]);
            }

            list.push(ls);
        })

        list.forEach(d => {
            let row = worksheet.addRow(d);
            row.eachCell((cell, number) => {
                cell.font = {
                    name: 'Calibri',
                    family: 2,
                    bold: false,
                    size: 12,
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
        });

        for (var i = 0; i < columnWidths.split(',').length; i++) {
            // const dobCol = worksheet.getColumn(i);
            // dobCol.eachCell({ includeEmpty: false }, function (cell, rowNumber) {
            //     cell.border = {
            //     top: { style: 'thin' },
            //     left: { style: 'thin' },
            //     bottom: { style: 'thin' },
            //     right: { style: 'thin' }
            //     }
            // });
            // if (i == 3) {
            //     worksheet.getColumn(i).width = 30;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // } else if (i == 11 || i == 12) {
            //     worksheet.getColumn(i).width = 50;
            //     worksheet.getColumn(i).alignment = { vertical: 'justify', horizontal: 'left', wrapText: true }
            // } else if (i == 5) {
            //     worksheet.getColumn(i).width = 40;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // } else if (i == 9 ||i==10) {
            //     worksheet.getColumn(i).width = 30;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // }
            // else {
                worksheet.getColumn(i+1).width = +columnWidths.split(',')[i];
                worksheet.getColumn(i+1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // }
        }
        titleRow.border = {
            top: { style: 'thin', color: { argb: 'FFFFFF' } },
            left: { style: 'thin', color: { argb: 'FFFFFF' } },
            bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
            right: { style: 'thin', color: { argb: 'FFFFFF' } }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        headerRow.height = 35;
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, reportTitle + '.xlsx');
        });        
    }

}